import * as React from "react";
export function SvgCloseButton(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg className="CloseButton_svg__$state$" width={14} height={14} {...props}>
      <style />
      <path
        d="M7.7 7l4.7-4.7c.2-.2.2-.5 0-.7s-.5-.2-.7 0L7 6.3 2.3 1.6c-.2-.2-.5-.2-.7 0s-.2.5 0 .7L6.3 7l-4.7 4.7c-.2.2-.2.5 0 .7s.5.2.7 0L7 7.7l4.7 4.7c.2.2.5.2.7 0s.2-.5 0-.7L7.7 7z"
        fill="#666"
      />
    </svg>
  );
}
